import { Enums } from '../../../../models/common'
import { OperatorLayoutSetting } from '../../../../models/local'
import { UserSessionService } from '../../../../services/user-session'

// #region Consts

export const SERVICE_NAME: string = 'LocationsMassGroupsEditService'

// #endregion

// #region Private Types

type MassLocationGroupsEditSettings = {
    detailsRowsVisibleState: boolean
}

// #endregion

// #region LocationsMassGroupsEditService

export class LocationsMassGroupsEditService {

    // #region Ctor

    constructor(
        private userSession: UserSessionService
    ) {
    }

    // #endregion

    // #region Public Methods

    public loadDetailsRowsVisibleState(): boolean {
        return this.loadComponentSettings().detailsRowsVisibleState
    }

    public saveDetailsRowsVisibleState(detailsRowsVisibleState: boolean): void {
        const importSettings: MassLocationGroupsEditSettings = this.loadComponentSettings()

        importSettings.detailsRowsVisibleState = detailsRowsVisibleState

        this.saveComponentSettings(importSettings)
    }

    // #endregion

    // #region Private Methods

    private loadComponentSettings(): MassLocationGroupsEditSettings {
        return this.userSession.getOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.MassLocationGroupsEdit), {
            detailsRowsVisibleState: false
        })
    }

    private saveComponentSettings(settings: MassLocationGroupsEditSettings): void {
        this.userSession.setOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.MassLocationGroupsEdit), settings)
    }

    // #endregion
}

// #endregion